export default __webpack_public_path__ + "static/media/Minfinlogo.e855d2ae.png";